import React, { PureComponent, Fragment } from 'react';

import { connect } from 'unistore/react';

import Headline from './Headline';
import Sharing from './Sharing';
import Infobox from './Infobox';

import actions from '~/state/Actions';

class Header extends PureComponent {
  render() {
    return (
      <Fragment>
        <Sharing setInfoboxContent={this.props.setInfoboxContent} />
        <Headline />
        <Infobox
          setInfoboxContent={this.props.setInfoboxContent}
          infoboxContent={this.props.infoboxContent}
        />
      </Fragment>
    );
  }
}

export default connect('infoboxContent', actions)(Header);
